/** Where a membership row came from: a direct invitation, or materialized from a master account's role. */
export const MembershipSource = {
  DIRECT: 'DIRECT',
  MASTER_ACCOUNT: 'MASTER_ACCOUNT'
} as const;

export type MembershipSource = (typeof MembershipSource)[keyof typeof MembershipSource];
